import React, { lazy } from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    name: 'Elena M.',
    location: 'CIUDAD DE MÉXICO, MX',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=70&w=160&h=160&auto=format&fit=crop',
    quote: 'Por primera vez en años, despierto con energía. La niebla mental desapareció por completo y por fin vuelvo a sentirme yo misma.'
  }, {
    name: 'Sara T.',
    location: 'BOGOTÁ, CO',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=70&w=160&h=160&auto=format&fit=crop',
    quote: "Pensé que mis síntomas eran 'normales' para mi edad. Este método me demostró que no, y me dio los pasos exactos para solucionarlos."
  }, {
    name: 'Lucía R.',
    location: 'BUENOS AIRES, AR',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=70&w=160&h=160&auto=format&fit=crop',
    quote: 'Sin dietas extremas, sin suplementos raros. Solo hábitos diarios simples que realmente funcionan. Mi hinchazón desapareció en dos semanas.'
  }];
  return <section className="py-14 md:py-20 bg-cream" data-id="element-195">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-196">
        <div className="text-center mb-10 md:mb-14" data-id="element-197">
          <FadeIn data-id="element-198">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-199">
              Historias Reales
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-200">
              La transformación de <em className="italic" data-id="element-201">otras mujeres</em>.
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-202">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-203">
              <div className="h-full flex flex-col items-center text-center group bg-sage/15 hover:bg-sage/25 border border-ink/5 px-5 md:px-7 py-8 md:py-10 transition-colors duration-500" data-id="element-204">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden mb-4 shadow-soft group-hover:scale-105 transition-transform duration-500" data-id="element-205">
                  <img src={t.image} alt={t.name} width={96} height={96} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-206" />
                </div>

                <div className="flex gap-1 mb-5 md:mb-6" data-id="element-207">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-sand text-sand" data-id="element-208" />)}
                </div>

                <div className="relative mb-8 flex-1" data-id="element-209">
                  <span className="absolute -top-6 -left-3 font-serif text-6xl text-sand/25 leading-none select-none" data-id="element-210">
                    "
                  </span>
                  <p className="font-serif text-lg md:text-xl text-ink italic leading-relaxed relative z-10 max-w-prose" data-id="element-211">
                    {t.quote}
                  </p>
                </div>

                <div className="mt-auto pt-2" data-id="element-212">
                  <p className="text-sm font-medium text-ink mb-1" data-id="element-213">{t.name}</p>
                  <p className="text-xs uppercase tracking-widest text-ink-light" data-id="element-214">
                    {t.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}